__turbopack_context__.v({
  "report-event-wrapper": "CreatorCollectionsLink-module-scss-module__9QE1aG__report-event-wrapper",
  "root": "CreatorCollectionsLink-module-scss-module__9QE1aG__root",
});
